var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActive
    ? _c("div", { staticClass: "frb frb-info", attrs: { id: "truevo" } }, [
        _c("input", {
          ref: "radio_method",
          attrs: {
            autocomplete: "off",
            type: "radio",
            id: "radio-button-" + _vm.methodCode,
            name: "radio-button",
          },
          domProps: { checked: _vm.methodSelected, value: "" + _vm.methodCode },
          on: { click: _vm.select },
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: "radio-button-" + _vm.methodCode } }, [
          _c("div", { staticClass: "card-body" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.showInvoiceFormLink
              ? _c("p", { staticClass: "small mb-1 mt-2" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.onShowInvoiceForm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$parent.wantReceiveInvoiceMessage) +
                          "\n        "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "processingpartner_chekout" }, [
      _c("ul", { staticClass: "list-unstyled list-inline" }, [
        _c("li", { staticClass: "list-inline-item" }, [
          _c("img", {
            staticClass: "img-responsive inline-block checkoutcard",
            attrs: {
              src: require("../../../../../static/templates/img/loghi_pagamenti/mastercard_checkout.png"),
              alt: "mastercard",
              height: "30",
            },
          }),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "list-inline-item" }, [
          _c("img", {
            staticClass: "img-responsive inline-block checkoutcard",
            attrs: {
              src: require("../../../../../static/templates/img/loghi_pagamenti/visa_checkout.png"),
              alt: "visa",
              height: "30",
            },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }